import {
    parseDt,
    stdDateFormat
} from './';
import {
    isBefore,
    format as dtFormat
} from '@formkit/tempo';

export function dtIsPast(dt: string | Date): boolean {
    return isBefore(parseDt(dt), new Date());
}

export function isDateValid(dt: Date | unknown): boolean {
    return dt instanceof Date && isFinite(+dt);
}

export function isToday(dt: string | Date): boolean {
    const dateToCheck = dtFormat(dt, stdDateFormat);
    const today = dtFormat(new Date(), stdDateFormat);
    return dateToCheck === today;
}
